import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  token: string | null;
  isAuthenticated: boolean;
}

const getInitialToken = (): string | null => {
  if (typeof window === "undefined") return null;
  // Хранилище может быть заблокировано (iframe LMS) — тогда токена нет.
  try {
    return localStorage.getItem("access_token");
  } catch {
    return null;
  }
};

const initialToken = getInitialToken();
const initialState: AuthState = {
  token: initialToken,
  isAuthenticated: !!initialToken,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
      state.isAuthenticated = true;
      // Сохраняем в localStorage
      if (typeof window !== "undefined") {
        localStorage.setItem("access_token", action.payload);
      }
    },
    logout: (state) => {
      state.token = null;
      state.isAuthenticated = false;
      // Удаляем из localStorage
      if (typeof window !== "undefined") {
        localStorage.removeItem("access_token");
      }
    },
  },
});

export const { setToken, logout } = authSlice.actions;
export default authSlice.reducer;
